<div ref="reviewsList" class="tt-c-reviews-list" v-if="total > 0 || showToolbar">
  <div class="tt-c-reviews-list__header tt-u-mb--md">
    <div ref="headingText" class="tt-c-reviews-list__heading" tabindex="-1" v-html="headingText"></div>
  </div>

  <tt-reviews-list-utilities :showToolbar="showToolbar"></tt-reviews-list-utilities>
  <tt-ask-results ref="searchResultsComponent"
                  v-if="showSearchResults"
                  class="tt-c-ask__results"
                  :initialPageSize="reviewsListConfig.searchInitialPageSize"
                  :pageSize="reviewsListConfig.searchPageSize"
                  :searchResults="searchResults"
                  :isOffline="isOffline"
                  :isSearching="isSearching"></tt-ask-results>

  <div v-if="!showSearchResults" class="tt-c-reviews-list__content">
    <tt-review v-for="review in reviews"
              @openMediaModal="openMediaModal"
              :allItemsInLayout="allItemsInLayout"
              :currentLayout="currentLayout"
              :isRelatedReview="currentSku !== review.catItem.sku"
              :mediaSize="mediaSize"
              :review="review"
              :showPurchaserBadge="reviewsListConfig.showPurchaserBadge"
              :slotNamesAfterShowDetails="slotNamesAfterShowDetails"
              :truncateLength="truncateLength"
              :key="review.id"></tt-review>
    <div v-if="noFilterResults" class="tt-c-reviews-list__text-content" v-html="$msg('reviewsList.numberOfReviews.filtered.none')"></div>
              
  </div>

  <div v-if="reviewsListConfig.useShowMore && !showSearchResults" class="tt-c-reviews-list__show-more">
    <div v-show="showMoreDisabled" class="tt-o-spinner"></div>
    <tt-button v-show="!showMoreDisabled && hasMoreRslts" @click="showMore" type="primary" class="tt-c-reviews-list__show-more-btn" v-html="$msg('reviewsList.showMore')"></tt-button>
  </div>
  <tt-pagination v-else-if="!reviewsListConfig.useShowMore && !showSearchResults" @updatePage="pageChange" :currentPage="currentPage" :total="totalReviews" :initialPageSize="initialPageSize" :pageSize="pageSize"></tt-pagination>
</div>



// WEBPACK FOOTER //
// ./src/components/reviews-list/reviews-list.html